import './assets/main.css'
import './common/style/common.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import registerPlugin from './plugin'
import { VueFuncallPlugin } from 'vue-funcall'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createSyncPlugin } from '@/pinia/plugins/create-sync-plugin'
import { VueQueryPlugin } from '@tanstack/vue-query'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
pinia.use(createSyncPlugin())

const app = createApp(App)

registerPlugin(app)

app.use(router)
app.use(store)
app.use(pinia)
app.use(VueFuncallPlugin)
app.use(VueQueryPlugin)
app.mount('#app')
